import React from 'react';
import { Dropdown } from '@packages/ui/composites/Dropdown';
import { Button } from '@packages/ui/primitives/Button';
import type { InternalActionDef } from '../schema/types';
import { ActionRegistry } from '../../registry/ActionRegistry';

interface ToolbarDropdownButtonProps {
  config: InternalActionDef;
  navigate?: (path: string, opts?: Record<string, unknown>) => void;
}

export function ToolbarDropdownButton({ config, navigate }: ToolbarDropdownButtonProps) {
  const label = config.label;
  const icon = config.icon ?? undefined;
  const options = config.options;
  const hasDropdown = Array.isArray(options) && options.length > 0;

  if (!hasDropdown) {
    return (
      <Button
        semanticId='multiSectionToolbarPrimary'
        variant='primary'
        label={label}
        icon={icon}
        onClick={() => {
          if (config.path && navigate) {
            navigate(config.path, config.state ? { state: config.state } : undefined);
          }
        }}
      />
    );
  }

  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <Button
          semanticId='multiSectionToolbarPrimary'
          variant='primary'
          label={label}
          icon={icon}
          trailingIcon='keyboard_arrow_down'
        />
      </Dropdown.Trigger>
      <Dropdown.Content>
        {options!.map((opt) => (
          <Dropdown.Item
            key={opt.actionId ?? opt.path}
            onSelect={async () => {
              if (opt.actionId && ActionRegistry.hasAction(opt.actionId)) {
                await ActionRegistry.executeAction(opt.actionId, {
                  pk: '',
                  row: {},
                  selectedKeys: [],
                  refreshTable: () => {},
                  clearSelection: () => {},
                });
                return;
              }
              if (opt.path && navigate) navigate(opt.path);
            }}>
            {opt.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Content>
    </Dropdown.Root>
  );
}
